import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const products = {
	state: {
		categorias : []
	},
	getters: {
		getCategorias:(state) => state.categorias,
		getCategoria: state => {

			return (slug) => {

				let categorias = state.categorias;

				let categoria = categorias.filter(cat => cat.slug == slug)[0];

				return categoria;

			}
		},
	},
	actions: {
		requestCategories : ({commit, getters}) => {
			return new Promise((resolve, reject) => {
				axios.get(`/api/${getters.getLanguage}/category`).then( result => {
					if(result.data.status){
						commit('setCategorias', result.data.data.items);
						resolve(result.data.data.items);
					}
				}).catch(error => {
					reject(error);
				});  
			});	
        },
        requestCategorie : ({commit, getters},category) => {
			return new Promise((resolve, reject) => {
				axios.get(`/api/${getters.getLanguage}/category?category=${category}`).then( result => {
					(result.data.status) ? resolve(result.data.data.items[0]) : reject(false);
				}).catch(error => {
					reject(error);
				});  
			});	
		},
		requestManufactureOfCategory : ({commit, getters},category) => {
			return new Promise((resolve, reject) => {
				axios.get(`/api/${getters.getLanguage}/manufacturer?category=${category}`).then( result => {
					(result.data.status) ? resolve(result.data.data.items) : reject(false);
				}).catch(error => {
					reject(error);
				});  
			});	
		},
        requestManufacture : ({commit, getters},manufacture) => { //NO SE USA
			return new Promise((resolve, reject) => {
				axios.get(`/api/${getters.getLanguage}/manufacturer?manufacturer=${manufacture}`).then( result => {
					(result.data.status) ? resolve(result.data.data.items) : reject(false);
				}).catch(error => {
					reject(error);
				});  
			});	
		},
		requestProductsOfManufacture : ({commit, getters},manufacture) => {
			return new Promise((resolve, reject) => {
			axios.get(`/api/${getters.getLanguage}/product?manufacturer=${manufacture}`).then( result => {
					(result.data.status) ? resolve(result.data.data.items) : reject(false);
				}).catch(error => {
					reject(error);
				});  
			});	
		},
		requestProductsOfCategory : ({commit, getters},category) => {
			return new Promise((resolve, reject) => {
			axios.get(`/api/${getters.getLanguage}/product?category=${category}`).then( result => {
					(result.data.status) ? resolve(result.data.data.items) : reject(false);
				}).catch(error => {
					reject(error);
				});  
			});	
		},
		requestProducts : ({commit, getters}) => {
			return new Promise((resolve, reject) => {
			axios.get(`/api/${getters.getLanguage}/product`).then( result => {
					(result.data.status) ? resolve(result.data.data.items) : reject(false);
				}).catch(error => {
					reject(error);
				});  
			});	
		},
	},
	mutations: {
		setCategorias(state, categorias){
			state.categorias = categorias;
		}
	}
}

export default products;



// WEBPACK FOOTER //
// ./src/store/products.js